import React, { useEffect, useState } from "react";
import { Flex, Modal} from "antd";
import { useNavigate} from "react-router-dom";
import { getFirestore, collection, getDocs, query, orderBy } from "firebase/firestore";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { Toaster } from "sonner";
import CarouselAntd from "../../../components/Carousel/CarouselAntd";
import Beneficios from "../../../components/Beneficios/Beneficios";
import CustomFooter from "../../../components/Footer/CustomFooter";
import Categories from "../../../components/Categorias/Categories";
import ProductosCerca from "../../../components/ProductosCerca/ProductosCerca";
import ServiciosCerca from "../../../components/ServiciosCerca/ServiciosCerca";

export default function Productos() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    obtenerImagenesCarrusel();
  }, []);

  const obtenerImagenesCarrusel = async () => {
    try {
      const db = getFirestore();
      const carruselRef = collection(db, "configuracionCarrusel");
      const q = query(carruselRef, orderBy("orden", "asc"));
      
      const querySnapshot = await getDocs(q);
      let docs = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filtrar visibles en memoria para evitar problemas de índices en Firebase
      docs = docs.filter(img => img.visible !== false);
      
      if (docs.length > 0) {
        setImagenes(docs);
      } else {
        // Fallback: Si no hay nada en Firestore, cargar directo de Storage
        await cargarDesdeStorage();
      }
    } catch (error) {
      console.error("Error al obtener las imágenes del carrusel (Firestore):", error);
      await cargarDesdeStorage();
    }
  };

  const cargarDesdeStorage = async () => {
    try {
      const storage = getStorage();
      const imagenesRef = ref(storage, "carrusel");
      const imagenesLista = await listAll(imagenesRef);
      const urlsPromises = imagenesLista.items.map(async (item) => {
        const url = await getDownloadURL(item);
        return { url, nombre: item.name };
      });
      const urls = await Promise.all(urlsPromises);
      setImagenes(urls);
    } catch (error) {
      console.error("Error al obtener las imágenes desde Storage:", error);
    }
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    navigate("/login");
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Flex justify="center" align="center" vertical>
      <CarouselAntd images={imagenes} />
   
   
      <Toaster richColors position="top-center" />
      <Beneficios />
      {/* <Recomendaciones /> */}
      <ProductosCerca />
      <ServiciosCerca />
      <Modal
        title="Autenticación Requerida"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Iniciar sesión"
        cancelText="Cancelar"
      >
        <p>Debes iniciar sesión para agregar productos al carrito</p>
      </Modal>
        <Categories/>

      <CustomFooter />
    </Flex>
  );
}
